export const seoKeywords = [
  "business electricity provider",
  "commercial power rate",
  "commercial electricity provider",
  "commercial electricity rates",
  "business electricity rates",
  "commercial energy broker",
  "business power supplier",
];

export const keywordLinks: Record<string, string> = {
  "business electricity provider": "/rates",
  "commercial power rate": "/rates",
  "commercial electricity rates": "/rates",
  "business electricity rates": "/rates",
  "commercial energy broker": "/industries",
  "business power supplier": "/industries",
};
